'use strict';
import React from 'react';
import flux from 'utils/flux';

var RedirectPage = React.createClass({
    displayName: 'RedirectPage',
    mixins: [],
    propTypes: {},
    statics: {
        willTransitionTo: function(transition) {
            if (flux.getStore('app').isAuthenticated()) {
                if ( !flux.getStore('app').hasAcceptedLatestTerms() ) {
                    transition.redirect( '/accept_terms', {}, {nextPath: transition.path} );
                }
                transition.redirect('listing');
            } else {
                transition.redirect('/login', {}, {nextPath: transition.path});
            }
        }
    },
    render() {
        return (<div/>);
    }
});

module.exports = RedirectPage;



// WEBPACK FOOTER //
// ./app/pages/redirect/index.jsx